import React from "react"
import { RouteContext, Section } from "../RouteProvider"

export function useRoute(): string {
  const context = React.useContext(RouteContext)
  if (context === undefined) {
    throw new Error("useRoute must be used within a RouteProvider")
  }
  return context.route
}

export function useSection(): Section | undefined {
  const context = React.useContext(RouteContext)
  if (context === undefined) {
    return undefined
  }
  return context.section
}

export function availableSections(): Section[] {
  const section = useSection()
  return Object.values(Section).filter((s) => s !== section && s !== undefined)
}
